import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddVideo from "../../../containers/superadmin/videos/models/add-video";
import SearchBar from "../../../containers/superadmin/videos/searchbar";
import VideosTable from "../../../containers/superadmin/videos/table";
import { getAllChaptersRequest } from "../../../modules/superadmin-modules/chapters/Actions";
import { getAllCoursesRequest } from "../../../modules/superadmin-modules/courses/Actions";
import {
  getAllVideosRequest,
  getCourseVideosRequest,
} from "../../../modules/superadmin-modules/videos/Actions";
const SuperadminVideos = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [courseId, setCourseId] = useState(null);

  useEffect(() => {
    dispatch(getAllChaptersRequest());
    dispatch(getAllCoursesRequest());
  }, []);

  useEffect(() => {
    if (courseId) {
      dispatch(getCourseVideosRequest(courseId));
    } else {
      dispatch(getAllVideosRequest());
    }
  }, [courseId]);
  console.log(courseId);
  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setCourseId={setCourseId}
      />
      <VideosTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddVideo
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminVideos;
